export default class {
    
    constructor(dto) {

        this.Guid = dto.Guid;

        this.Name = dto.Name;

        this.Type = dto.Type;

        this.Comment = dto.Comment;

        this.Activities = dto.Activities;

        this.DateCreated = dto.DateCreated;

        this.CreationLocation = dto.CreationLocation;

        this.DateFinished = dto.DateFinished;

        this.CompletionLocation = dto.CompletionLocation;      

        this.Creator = dto.Creator;

        this.KPI = dto.KPI;

        this.Forms = dto.Forms;

        this.UserErrors = dto.UserErrors;

        this.SelectedForm = null;
        this.IndexForm = 0;

        this.IsTTVisible = false;
        this.IsQuestionsVisible = false;       
        this.IsPhotosVisible = false;
    }

    LoseVisibility() {

        this.IsTTVisible = false;
        this.IsQuestionsVisible = false;    
        this.IsAnswersVisible = false;    
        this.IsSubQuestionsVisible = false;    
        this.IsPhotosVisible = false;
    }

    SelectForm(index) {
        this.SelectedForm = this.Forms[index];
        this.IndexForm = index;
        this.LoseVisibility();
    }

    ShowTradePoint(index) {
        if(index == null) 
            return;

        this.SelectForm(index)
        this.IsTTVisible = true;
    }

    ShowQuestions(index) {
        if(index == null) 
            return;       

        this.SelectForm(index);
        this.IsQuestionsVisible = true;
    }

    ShowPhotos(index) {  
        if(index == null) 
            return;

        this.SelectForm(index);
        this.IsPhotosVisible = true;
    }

    // ShowAnswers = function(index) {
    //     if(index != null)
    //         this.Answers = this.Questions[index].Answers;

    //     this.LoseVisibility();
    //     this.IsAnswersVisible = true;
    // }

    // ShowSubQuestions = function(index){
    //     this.LoseVisibility();
    //     this.IsSubQuestionsVisible = true;
    //     this.SubQuestions = this.Answers[index].Questions;
    // }
}